export const DATE_FORMAT = 'dd-MM-yyyy'
export const DATE_MOMENT_FORMAT = 'DD-MM-YYYY'
export const DATE_SERVER_FORMAT = "yyyy-MM-dd HH:mm:ss.fff";
export const DATE_MOMENT_SERVER_FORMAT = "YYYY-MM-DD HH:mm:ss.SSS";
export const DATE_PARSE_FORMAT = [DATE_SERVER_FORMAT, "yyyy-MM-dd HH:mm:ss", "dd/MM/yyyy", "dd-MM-yyyy", "dd-MM-yy", "dd/MM/yyyy", "dd/MM/yy", "ddMMyyyy", "ddMMyy", "ddMM"];
